"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var createRecord_1 = require("./createRecord");
var preventEvents_1 = require("../utils/preventEvents");
var debounce_1 = require("../utils/debounce");
var getFacetValue = function (_this, type) {
    if (type === 'range') {
        return _this.filter(function (_, k) { return k === 'from' || k === 'to'; });
    }
    ;
    return _this.get('value');
};
var updateFilters = function (filterName, _value, isSelected, type) {
    return function (f) {
        if (f === void 0) { f = immutable_1.Map(); }
        return f.withMutations(function (filters) {
            var isCategory = type === 'category';
            var value = isCategory ? immutable_1.List([_value]) : _value;
            var _a = filterName.split(/(?=\d+)/), key = _a[0], n = _a[1];
            if (isSelected) {
                var index = filters.get(filterName).indexOf(value);
                if (!isCategory)
                    return filters.removeIn([filterName, index]);
                filters.forEach(function (_, _fName) {
                    if (!_fName.includes(key) || Number(_fName.split(/(?=\d+)/)[1]) < Number(n))
                        return;
                    return filters.remove(_fName);
                });
                return filters;
            }
            if (filters.has(filterName) || (isCategory && filters.find(function (_, k) { return k.includes(key); }))) {
                if (isCategory) {
                    filters.forEach(function (_, _fName) {
                        if (!_fName.includes(key) || Number(_fName.split(/(?=\d+)/)[1]) < Number(n))
                            return;
                        return filters.remove(_fName);
                    });
                    return filters.set(filterName, immutable_1.fromJS([value]));
                }
                ;
                return filters.set(filterName, filters.get(filterName).push(value));
            }
            return filters.set(filterName, immutable_1.fromJS([value]));
        });
    };
};
var Facet = (function (_super) {
    __extends(Facet, _super);
    function Facet(facet, updater) {
        var _this_1 = _super.call(this, facet.update('values', function (values) {
            return values.map(function (v) { return new FacetValue(v, updater, facet); });
        })) || this;
        _this_1.resetValues = function (e) {
            preventEvents_1.preventEvents(e);
            var name = _this_1.get('name');
            if (_this_1.get('type') === 'category') {
                _this_1.updater('filters', function (f) { return f && f.filter(function (v, k) { return !k.includes(name); }); });
            }
            else {
                _this_1.updater('filters', function (f) { return f && f.remove(name); });
            }
            return _this_1;
        };
        _this_1.setValue = function (value) {
            if (!value)
                return _this_1;
            _this_1.updater('filters', updateFilters(_this_1.get('name'), immutable_1.fromJS(value), false, _this_1.get('type')));
            return _this_1;
        };
        _this_1.updater = updater;
        return _this_1;
    }
    ;
    return Facet;
}(createRecord_1.default('Facet')));
exports.Facet = Facet;
var FacetValue = (function (_super) {
    __extends(FacetValue, _super);
    function FacetValue(value, updater, facet) {
        var _this_1 = _super.call(this, value.update('children', function (children) { return children &&
            children.map(function (v) { return new FacetValue(v, updater, facet); }); })) || this;
        _this_1.toggle = debounce_1.default(function (e) {
            preventEvents_1.preventEvents(e);
            var value = getFacetValue(_this_1, _this_1.type);
            _this_1.updater('filters', updateFilters(_this_1.index, value, _this_1.get('selected'), _this_1.type));
            return _this_1;
        }, 300, true);
        _this_1.updater = updater;
        _this_1.index = value.get('name');
        _this_1.type = facet.get('type');
        return _this_1;
    }
    return FacetValue;
}(createRecord_1.default('FacetValue')));
exports.FacetValue = FacetValue;
//# sourceMappingURL=facets.js.map